<template>
  <div class="content-list">
    <h4 class="content-list__title">
      <post-link
        :post="content"
        :title="content.title"
        class="content-list__link"
      >
        {{ content.title }}
      </post-link>
    </h4>
    <ul class="content-list__meta">
      <li class="content-list__meta-item">
        {{ content.publishedAt | fullDate }}
      </li>
      <li class="content-list__meta-item">
        {{ content.source && content.source.name }}
      </li>
      <li class="content-list__meta-item">
        <span class="fa fa-comments" />
        {{ content.commentsCount }}
      </li>
      <li class="content-list__meta-item">
        <span class="fa fa-eye" />
        {{ content.views }}
      </li>
      <li class="content-list__meta-item">
        <span class="fa fa-tags" />
        {{ content.tags.map(({ name }) => (name)).sort().join(', ') }}
      </li>
    </ul>

    <div class="content-list__options">
      <div
        v-if="content.priority === 'high'"
        class="content-list__priority"
      >!</div>

      <div
        class="content-list__settings"
      >
        <dropdown-input
          :options="dropdownOptions"
          theme="primary"
          position="right"
          @select="handleDropdownSelect"
        >
          <button>
            <span class="fa fa-ellipsis-h" />
          </button>
        </dropdown-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import fullDate from '@/filters/fullDate'
import FormMixin from '@/mixins/forms/Form'
import PostLink from '@/components/posts/PostLink'

export default {
  name: 'PostList',
  mixins: [FormMixin],
  components: {
    PostLink
  },
  filters: {
    fullDate
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    dropdownOptions () {
      return [
        { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
        { label: 'Kopieren', value: 'copy', icon: 'copy' },
        { label: 'Löschen', value: 'delete', icon: 'trash' }
      ]
    }
  },
  methods: {
    ...mapActions({
      fetchContentsForFolder: 'contents/fetchForFolder',
      openContentModalContent: 'openContentModalContent',
      openContentCopyModal: 'openContentCopyModal',
      openConfirmModal: 'openConfirmModal',
      closeConfirmModal:'closeConfirmModal',
      setContents: 'contents/apply',
      destroyContent: 'destroyContent'
    }),

    handleDropdownSelect ({ value }) {
      switch (value) {
        case 'edit':
          this.openContentModalContent(this.content.id)
          break
        case 'copy':
          this.openContentCopyModal(this.content.id)
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Artikel löschen',
            message: `Den Artikel ${this.content.title} wirklich löschen?`,
            callback: () => {
              this.destroyContent(this.content.id)
                .then(() => {
                  this.fetchContentsForFolder(this.$route.params.folderId)
                    .then((response) => {
                      this.setContents(response)
                      this.$emit('loadingDone')
                    })
                })
                .then(this.closeConfirmModal)
            }
          })
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.content-list
  position: relative
  padding: rem-calc(30 0)
  border-bottom: 1px solid $color-grey-1

  &:first-of-type
    border-top: 1px solid $color-grey-1

  &__title
    +font-size(24, 30)
    color: $color-black
    margin: rem-calc(0 0 6 0)
    width: 85%
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

  &__link
    color: $color-black

  &__meta
    &-item
      +font-size(14, 18)
      display: inline-block
      margin-right: rem-calc(10)
      color: $color-grey-2

    &-item + &-item
      border-left: 1px solid $color-grey-1
      padding-left: rem-calc(10)

  &__options
    display: flex
    flex-direction: row
    justify-content: flex-end
    align-items: center

    position: absolute
    right: 0
    top: 0
    bottom: 0

  &__priority
      +font-size(14, 24)
      width: rem-calc(24)
      height: rem-calc(24)
      background: $color-error
      border-radius: 50%
      text-align: center
      font-weight: 900
      color: $color-white

  &__settings
    position: relative;

    button
      +font-size(14, 42)
      color: $color-grey-3
      border: 1px solid $color-grey-1
      width: rem-calc(54)
      height: rem-calc(42)
      border-radius: 3px
      margin-left: rem-calc(16)
</style>





// WEBPACK FOOTER //
// src/components/posts/PostList.vue